import { jsx as _jsx } from "react/jsx-runtime";
import { useFetchPromise } from '@rad/hooks';
import { getPartners } from '../../../../common/network/partner';
import PartnershipsStrip from './partnerships-strip';
// Partner districts and organizations. Which communities appear, and in what
// order, is managed under System → Partners; title, logo, and link come from
// each community's own record, so a rename or a rebrand in the admin flows
// through here without a deploy.
const PartnershipsSection = (props) => {
    const [partners] = useFetchPromise(getPartners);
    return _jsx(PartnershipsStrip, { partners: partners !== null && partners !== void 0 ? partners : [] });
};
export default PartnershipsSection;
